declare namespace $ {

	type $bog_favicon__Icon_bog_builderui_studio_1 = $mol_type_enforce<
		ReturnType< $bog_builderui_studio['favicon_icon'] >
		,
		ReturnType< $bog_favicon['Icon'] >
	>
	type $bog_builderui_skin__lights_bog_builderui_studio_2 = $mol_type_enforce<
		ReturnType< $bog_builderui_studio['lights'] >
		,
		ReturnType< $bog_builderui_skin['lights'] >
	>
	type $bog_builderui_skin__base_bog_builderui_studio_3 = $mol_type_enforce<
		ReturnType< $bog_builderui_studio['base'] >
		,
		ReturnType< $bog_builderui_skin['base'] >
	>
	type $bog_builderui_skin__accent_bog_builderui_studio_4 = $mol_type_enforce<
		ReturnType< $bog_builderui_studio['theme'] >
		,
		ReturnType< $bog_builderui_skin['accent'] >
	>
	type $bog_builderui_skin__chart_bog_builderui_studio_5 = $mol_type_enforce<
		ReturnType< $bog_builderui_studio['chart'] >
		,
		ReturnType< $bog_builderui_skin['chart'] >
	>
	type $bog_builderui_skin__radius_bog_builderui_studio_6 = $mol_type_enforce<
		ReturnType< $bog_builderui_studio['radius'] >
		,
		ReturnType< $bog_builderui_skin['radius'] >
	>
	type $bog_builderui_skin__font_body_bog_builderui_studio_7 = $mol_type_enforce<
		ReturnType< $bog_builderui_studio['font_body'] >
		,
		ReturnType< $bog_builderui_skin['font_body'] >
	>
	type $bog_builderui_skin__font_head_bog_builderui_studio_8 = $mol_type_enforce<
		ReturnType< $bog_builderui_studio['font_head'] >
		,
		ReturnType< $bog_builderui_skin['font_head'] >
	>
	type $mol_view__sub_bog_builderui_studio_9 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $bog_builderui_studio_pick__label_bog_builderui_studio_10 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_builderui_studio_pick['label'] >
	>
	type $bog_builderui_studio_pick__value_bog_builderui_studio_11 = $mol_type_enforce<
		ReturnType< $bog_builderui_studio['style_id'] >
		,
		ReturnType< $bog_builderui_studio_pick['value'] >
	>
	type $bog_builderui_studio_pick__dictionary_bog_builderui_studio_12 = $mol_type_enforce<
		ReturnType< $bog_builderui_studio['style_dict'] >
		,
		ReturnType< $bog_builderui_studio_pick['dictionary'] >
	>
	type $mol_view__sub_bog_builderui_studio_13 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $bog_builderui_studio_pick__label_bog_builderui_studio_14 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_builderui_studio_pick['label'] >
	>
	type $bog_builderui_studio_pick__value_bog_builderui_studio_15 = $mol_type_enforce<
		ReturnType< $bog_builderui_studio['base'] >
		,
		ReturnType< $bog_builderui_studio_pick['value'] >
	>
	type $bog_builderui_studio_pick__dot_color_bog_builderui_studio_16 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_builderui_studio_pick['dot_color'] >
	>
	type $bog_builderui_studio_pick__dictionary_bog_builderui_studio_17 = $mol_type_enforce<
		({ 
			'slate': string,
			'stone': string,
			'zinc': string,
			'gray': string,
		}) 
		,
		ReturnType< $bog_builderui_studio_pick['dictionary'] >
	>
	type $bog_builderui_studio_pick__label_bog_builderui_studio_18 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_builderui_studio_pick['label'] >
	>
	type $bog_builderui_studio_pick__value_bog_builderui_studio_19 = $mol_type_enforce<
		ReturnType< $bog_builderui_studio['theme'] >
		,
		ReturnType< $bog_builderui_studio_pick['value'] >
	>
	type $bog_builderui_studio_pick__dot_color_bog_builderui_studio_20 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_builderui_studio_pick['dot_color'] >
	>
	type $bog_builderui_studio_pick__dictionary_bog_builderui_studio_21 = $mol_type_enforce<
		({ 
			'sky': string,
			'rose': string,
			'violet': string,
			'emerald': string,
			'amber': string,
		}) 
		,
		ReturnType< $bog_builderui_studio_pick['dictionary'] >
	>
	type $bog_builderui_studio_pick__label_bog_builderui_studio_22 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_builderui_studio_pick['label'] >
	>
	type $bog_builderui_studio_pick__value_bog_builderui_studio_23 = $mol_type_enforce<
		ReturnType< $bog_builderui_studio['chart'] >
		,
		ReturnType< $bog_builderui_studio_pick['value'] >
	>
	type $bog_builderui_studio_pick__dot_color_bog_builderui_studio_24 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_builderui_studio_pick['dot_color'] >
	>
	type $bog_builderui_studio_pick__dictionary_bog_builderui_studio_25 = $mol_type_enforce<
		({ 
			'blue': string,
			'green': string,
			'red': string,
			'yellow': string,
			'purple': string,
		}) 
		,
		ReturnType< $bog_builderui_studio_pick['dictionary'] >
	>
	type $mol_view__sub_bog_builderui_studio_26 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $bog_builderui_studio_pick__label_bog_builderui_studio_27 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_builderui_studio_pick['label'] >
	>
	type $bog_builderui_studio_pick__value_bog_builderui_studio_28 = $mol_type_enforce<
		ReturnType< $bog_builderui_studio['font_head'] >
		,
		ReturnType< $bog_builderui_studio_pick['value'] >
	>
	type $bog_builderui_studio_pick__dictionary_bog_builderui_studio_29 = $mol_type_enforce<
		({ 
			'inter': string,
			'manrope': string,
			'dm-sans': string,
			'eb-garamond': string,
		}) 
		,
		ReturnType< $bog_builderui_studio_pick['dictionary'] >
	>
	type $bog_builderui_studio_pick__label_bog_builderui_studio_30 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_builderui_studio_pick['label'] >
	>
	type $bog_builderui_studio_pick__value_bog_builderui_studio_31 = $mol_type_enforce<
		ReturnType< $bog_builderui_studio['font_body'] >
		,
		ReturnType< $bog_builderui_studio_pick['value'] >
	>
	type $bog_builderui_studio_pick__dictionary_bog_builderui_studio_32 = $mol_type_enforce<
		({ 
			'inter': string,
			'manrope': string,
			'dm-sans': string,
			'eb-garamond': string,
		}) 
		,
		ReturnType< $bog_builderui_studio_pick['dictionary'] >
	>
	type $mol_view__sub_bog_builderui_studio_33 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $bog_builderui_studio_pick__label_bog_builderui_studio_34 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_builderui_studio_pick['label'] >
	>
	type $bog_builderui_studio_pick__value_bog_builderui_studio_35 = $mol_type_enforce<
		ReturnType< $bog_builderui_studio['radius'] >
		,
		ReturnType< $bog_builderui_studio_pick['value'] >
	>
	type $bog_builderui_studio_pick__dictionary_bog_builderui_studio_36 = $mol_type_enforce<
		({ 
			'none': string,
			'small': string,
			'medium': string,
			'large': string,
		}) 
		,
		ReturnType< $bog_builderui_studio_pick['dictionary'] >
	>
	type $bog_builderui_studio_pick__label_bog_builderui_studio_37 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_builderui_studio_pick['label'] >
	>
	type $bog_builderui_studio_pick__value_bog_builderui_studio_38 = $mol_type_enforce<
		ReturnType< $bog_builderui_studio['lights'] >
		,
		ReturnType< $bog_builderui_studio_pick['value'] >
	>
	type $bog_builderui_studio_pick__dictionary_bog_builderui_studio_39 = $mol_type_enforce<
		({ 
			'dark': string,
			'light': string,
		}) 
		,
		ReturnType< $bog_builderui_studio_pick['dictionary'] >
	>
	type $mol_view__sub_bog_builderui_studio_40 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_button_minor__title_bog_builderui_studio_41 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_bog_builderui_studio_42 = $mol_type_enforce<
		ReturnType< $bog_builderui_studio['shuffle'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__title_bog_builderui_studio_43 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_bog_builderui_studio_44 = $mol_type_enforce<
		ReturnType< $bog_builderui_studio['share'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_view__sub_bog_builderui_studio_45 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_button_major__title_bog_builderui_studio_46 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_major['title'] >
	>
	type $mol_button_major__click_bog_builderui_studio_47 = $mol_type_enforce<
		ReturnType< $bog_builderui_studio['get_code'] >
		,
		ReturnType< $mol_button_major['click'] >
	>
	type $mol_view__sub_bog_builderui_studio_48 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_builderui_studio_49 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $bog_builderui_button__title_bog_builderui_studio_50 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_builderui_button['title'] >
	>
	type $bog_builderui_button__title_bog_builderui_studio_51 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_builderui_button['title'] >
	>
	type $bog_builderui_button__variant_bog_builderui_studio_52 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_builderui_button['variant'] >
	>
	type $bog_builderui_button__title_bog_builderui_studio_53 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_builderui_button['title'] >
	>
	type $bog_builderui_button__variant_bog_builderui_studio_54 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_builderui_button['variant'] >
	>
	type $bog_builderui_button__title_bog_builderui_studio_55 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_builderui_button['title'] >
	>
	type $bog_builderui_button__variant_bog_builderui_studio_56 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_builderui_button['variant'] >
	>
	type $mol_view__sub_bog_builderui_studio_57 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $bog_builderui_card__sub_bog_builderui_studio_58 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $bog_builderui_card['sub'] >
	>
	type $mol_view__sub_bog_builderui_studio_59 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $bog_builderui_badge__title_bog_builderui_studio_60 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_builderui_badge['title'] >
	>
	type $bog_builderui_badge__title_bog_builderui_studio_61 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_builderui_badge['title'] >
	>
	type $bog_builderui_badge__variant_bog_builderui_studio_62 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_builderui_badge['variant'] >
	>
	type $bog_builderui_badge__title_bog_builderui_studio_63 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_builderui_badge['title'] >
	>
	type $bog_builderui_badge__variant_bog_builderui_studio_64 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_builderui_badge['variant'] >
	>
	type $bog_builderui_badge__title_bog_builderui_studio_65 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_builderui_badge['title'] >
	>
	type $bog_builderui_badge__variant_bog_builderui_studio_66 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_builderui_badge['variant'] >
	>
	type $mol_view__sub_bog_builderui_studio_67 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $bog_builderui_card__sub_bog_builderui_studio_68 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $bog_builderui_card['sub'] >
	>
	type $mol_view__sub_bog_builderui_studio_69 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $bog_builderui_tabs__value_bog_builderui_studio_70 = $mol_type_enforce<
		ReturnType< $bog_builderui_studio['tabs_value'] >
		,
		ReturnType< $bog_builderui_tabs['value'] >
	>
	type $bog_builderui_tabs__options_bog_builderui_studio_71 = $mol_type_enforce<
		({ 
			'overview': string,
			'activity': string,
			'settings': string,
		}) 
		,
		ReturnType< $bog_builderui_tabs['options'] >
	>
	type $bog_builderui_card__sub_bog_builderui_studio_72 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $bog_builderui_card['sub'] >
	>
	type $mol_view__sub_bog_builderui_studio_73 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $bog_builderui_select__value_bog_builderui_studio_74 = $mol_type_enforce<
		ReturnType< $bog_builderui_studio['select_value'] >
		,
		ReturnType< $bog_builderui_select['value'] >
	>
	type $bog_builderui_select__dictionary_bog_builderui_studio_75 = $mol_type_enforce<
		({ 
			'none': string,
			'small': string,
			'medium': string,
			'large': string,
		}) 
		,
		ReturnType< $bog_builderui_select['dictionary'] >
	>
	type $bog_builderui_card__sub_bog_builderui_studio_76 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $bog_builderui_card['sub'] >
	>
	type $mol_view__sub_bog_builderui_studio_77 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_builderui_studio_78 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $bog_builderui_card__sub_bog_builderui_studio_79 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $bog_builderui_card['sub'] >
	>
	type $bog_builderui_alert__title_bog_builderui_studio_80 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_builderui_alert['title'] >
	>
	type $bog_builderui_alert__text_bog_builderui_studio_81 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_builderui_alert['text'] >
	>
	type $mol_view__sub_bog_builderui_studio_82 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $bog_builderui_toast__kind_bog_builderui_studio_83 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_builderui_toast['kind'] >
	>
	type $bog_builderui_toast__title_bog_builderui_studio_84 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_builderui_toast['title'] >
	>
	type $bog_builderui_toast__text_bog_builderui_studio_85 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_builderui_toast['text'] >
	>
	type $bog_builderui_toast__kind_bog_builderui_studio_86 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_builderui_toast['kind'] >
	>
	type $bog_builderui_toast__title_bog_builderui_studio_87 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_builderui_toast['title'] >
	>
	type $bog_builderui_toast__text_bog_builderui_studio_88 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_builderui_toast['text'] >
	>
	type $bog_builderui_toast__kind_bog_builderui_studio_89 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_builderui_toast['kind'] >
	>
	type $bog_builderui_toast__title_bog_builderui_studio_90 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_builderui_toast['title'] >
	>
	type $bog_builderui_toast__text_bog_builderui_studio_91 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_builderui_toast['text'] >
	>
	type $bog_builderui_toast__kind_bog_builderui_studio_92 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_builderui_toast['kind'] >
	>
	type $bog_builderui_toast__title_bog_builderui_studio_93 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_builderui_toast['title'] >
	>
	type $bog_builderui_toast__text_bog_builderui_studio_94 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_builderui_toast['text'] >
	>
	type $bog_builderui_card__sub_bog_builderui_studio_95 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $bog_builderui_card['sub'] >
	>
	type $mol_view__sub_bog_builderui_studio_96 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $bog_builderui_avatar__uri_bog_builderui_studio_97 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_builderui_avatar['uri'] >
	>
	type $bog_builderui_avatar__uri_bog_builderui_studio_98 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_builderui_avatar['uri'] >
	>
	type $bog_builderui_avatar__uri_bog_builderui_studio_99 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_builderui_avatar['uri'] >
	>
	type $mol_avatar__id_bog_builderui_studio_100 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_avatar['id'] >
	>
	type $mol_avatar__id_bog_builderui_studio_101 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_avatar['id'] >
	>
	type $mol_avatar__id_bog_builderui_studio_102 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_avatar['id'] >
	>
	type $mol_view__sub_bog_builderui_studio_103 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $bog_builderui_card__sub_bog_builderui_studio_104 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $bog_builderui_card['sub'] >
	>
	type $mol_view__sub_bog_builderui_studio_105 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $bog_builderui_slider__value_bog_builderui_studio_106 = $mol_type_enforce<
		ReturnType< $bog_builderui_studio['slider_value'] >
		,
		ReturnType< $bog_builderui_slider['value'] >
	>
	type $bog_builderui_slider__min_bog_builderui_studio_107 = $mol_type_enforce<
		number
		,
		ReturnType< $bog_builderui_slider['min'] >
	>
	type $bog_builderui_slider__max_bog_builderui_studio_108 = $mol_type_enforce<
		number
		,
		ReturnType< $bog_builderui_slider['max'] >
	>
	type $bog_builderui_card__sub_bog_builderui_studio_109 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $bog_builderui_card['sub'] >
	>
	type $mol_view__sub_bog_builderui_studio_110 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $bog_builderui_progress__value_bog_builderui_studio_111 = $mol_type_enforce<
		number
		,
		ReturnType< $bog_builderui_progress['value'] >
	>
	type $bog_builderui_progress__max_bog_builderui_studio_112 = $mol_type_enforce<
		number
		,
		ReturnType< $bog_builderui_progress['max'] >
	>
	type $bog_builderui_card__sub_bog_builderui_studio_113 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $bog_builderui_card['sub'] >
	>
	type $mol_view__sub_bog_builderui_studio_114 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $bog_builderui_button__title_bog_builderui_studio_115 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_builderui_button['title'] >
	>
	type $bog_builderui_tooltip__Anchor_bog_builderui_studio_116 = $mol_type_enforce<
		ReturnType< $bog_builderui_studio['Tooltip_anchor'] >
		,
		ReturnType< $bog_builderui_tooltip['Anchor'] >
	>
	type $bog_builderui_tooltip__bubble_content_bog_builderui_studio_117 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $bog_builderui_tooltip['bubble_content'] >
	>
	type $bog_builderui_card__sub_bog_builderui_studio_118 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $bog_builderui_card['sub'] >
	>
	type $mol_view__sub_bog_builderui_studio_119 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $bog_builderui_card__sub_bog_builderui_studio_120 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $bog_builderui_card['sub'] >
	>
	type $mol_view__sub_bog_builderui_studio_121 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $bog_builderui_button__title_bog_builderui_studio_122 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_builderui_button['title'] >
	>
	type $bog_builderui_button__click_bog_builderui_studio_123 = $mol_type_enforce<
		ReturnType< $bog_builderui_studio['dialog_open'] >
		,
		ReturnType< $bog_builderui_button['click'] >
	>
	type $bog_builderui_card__sub_bog_builderui_studio_124 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $bog_builderui_card['sub'] >
	>
	type $mol_view__sub_bog_builderui_studio_125 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_builderui_studio_126 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_builderui_studio_127 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $bog_builderui_field__hint_bog_builderui_studio_128 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_builderui_field['hint'] >
	>
	type $mol_view__sub_bog_builderui_studio_129 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_builderui_studio_130 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_builderui_studio_131 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $bog_builderui_field__hint_bog_builderui_studio_132 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_builderui_field['hint'] >
	>
	type $bog_builderui_field__type_bog_builderui_studio_133 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_builderui_field['type'] >
	>
	type $mol_view__sub_bog_builderui_studio_134 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $bog_builderui_button__title_bog_builderui_studio_135 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_builderui_button['title'] >
	>
	type $bog_builderui_button__title_bog_builderui_studio_136 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_builderui_button['title'] >
	>
	type $mol_view__sub_bog_builderui_studio_137 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $bog_builderui_card__sub_bog_builderui_studio_138 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $bog_builderui_card['sub'] >
	>
	type $mol_view__sub_bog_builderui_studio_139 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $bog_builderui_field__hint_bog_builderui_studio_140 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_builderui_field['hint'] >
	>
	type $bog_builderui_card__sub_bog_builderui_studio_141 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $bog_builderui_card['sub'] >
	>
	type $mol_view__sub_bog_builderui_studio_142 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $bog_builderui_menu_item__title_bog_builderui_studio_143 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_builderui_menu_item['title'] >
	>
	type $bog_builderui_menu_item__title_bog_builderui_studio_144 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_builderui_menu_item['title'] >
	>
	type $bog_builderui_menu_item__title_bog_builderui_studio_145 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_builderui_menu_item['title'] >
	>
	type $bog_builderui_menu__items_bog_builderui_studio_146 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $bog_builderui_menu['items'] >
	>
	type $bog_builderui_card__sub_bog_builderui_studio_147 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $bog_builderui_card['sub'] >
	>
	type $mol_view__sub_bog_builderui_studio_148 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $bog_builderui_breadcrumbs_item__title_bog_builderui_studio_149 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_builderui_breadcrumbs_item['title'] >
	>
	type $bog_builderui_breadcrumbs_item__path_bog_builderui_studio_150 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_builderui_breadcrumbs_item['path'] >
	>
	type $bog_builderui_breadcrumbs_item__title_bog_builderui_studio_151 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_builderui_breadcrumbs_item['title'] >
	>
	type $bog_builderui_breadcrumbs_item__path_bog_builderui_studio_152 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_builderui_breadcrumbs_item['path'] >
	>
	type $bog_builderui_breadcrumbs_item__title_bog_builderui_studio_153 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_builderui_breadcrumbs_item['title'] >
	>
	type $bog_builderui_breadcrumbs_item__path_bog_builderui_studio_154 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_builderui_breadcrumbs_item['path'] >
	>
	type $bog_builderui_breadcrumbs__items_bog_builderui_studio_155 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $bog_builderui_breadcrumbs['items'] >
	>
	type $bog_builderui_card__sub_bog_builderui_studio_156 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $bog_builderui_card['sub'] >
	>
	type $mol_view__sub_bog_builderui_studio_157 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_app_quine__Head_bog_builderui_studio_158 = $mol_type_enforce<
		any
		,
		ReturnType< $mol_app_quine['Head'] >
	>
	type $mol_app_quine__paths_bog_builderui_studio_159 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_app_quine['paths'] >
	>
	type $bog_builderui_card__sub_bog_builderui_studio_160 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $bog_builderui_card['sub'] >
	>
	type $mol_view__sub_bog_builderui_studio_161 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_plot_bar__title_bog_builderui_studio_162 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_plot_bar['title'] >
	>
	type $mol_plot_bar__series_y_bog_builderui_studio_163 = $mol_type_enforce<
		ReturnType< $bog_builderui_studio['chart_visits'] >
		,
		ReturnType< $mol_plot_bar['series_y'] >
	>
	type $mol_plot_bar__color_bog_builderui_studio_164 = $mol_type_enforce<
		ReturnType< $bog_builderui_studio['chart_color_visits'] >
		,
		ReturnType< $mol_plot_bar['color'] >
	>
	type $mol_plot_bar__title_bog_builderui_studio_165 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_plot_bar['title'] >
	>
	type $mol_plot_bar__series_y_bog_builderui_studio_166 = $mol_type_enforce<
		ReturnType< $bog_builderui_studio['chart_signups'] >
		,
		ReturnType< $mol_plot_bar['series_y'] >
	>
	type $mol_plot_bar__color_bog_builderui_studio_167 = $mol_type_enforce<
		ReturnType< $bog_builderui_studio['chart_color_signups'] >
		,
		ReturnType< $mol_plot_bar['color'] >
	>
	type $mol_plot_bar__title_bog_builderui_studio_168 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_plot_bar['title'] >
	>
	type $mol_plot_bar__series_y_bog_builderui_studio_169 = $mol_type_enforce<
		ReturnType< $bog_builderui_studio['chart_logins'] >
		,
		ReturnType< $mol_plot_bar['series_y'] >
	>
	type $mol_plot_bar__color_bog_builderui_studio_170 = $mol_type_enforce<
		ReturnType< $bog_builderui_studio['chart_color_logins'] >
		,
		ReturnType< $mol_plot_bar['color'] >
	>
	type $mol_plot_mark_hor__title_bog_builderui_studio_171 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_plot_mark_hor['title'] >
	>
	type $mol_plot_mark_hor__labels_bog_builderui_studio_172 = $mol_type_enforce<
		ReturnType< $bog_builderui_studio['chart_labels'] >
		,
		ReturnType< $mol_plot_mark_hor['labels'] >
	>
	type $mol_plot_ruler_vert__title_bog_builderui_studio_173 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_plot_ruler_vert['title'] >
	>
	type $bog_builderui_chart__graphs_bog_builderui_studio_174 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $bog_builderui_chart['graphs'] >
	>
	type $bog_builderui_card__sub_bog_builderui_studio_175 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $bog_builderui_card['sub'] >
	>
	type $bog_builderui_gallery__items_bog_builderui_studio_176 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $bog_builderui_gallery['items'] >
	>
	type $mol_scroll__sub_bog_builderui_studio_177 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_scroll['sub'] >
	>
	type $bog_builderui_dialog__showed_bog_builderui_studio_178 = $mol_type_enforce<
		ReturnType< $bog_builderui_studio['dialog_showed'] >
		,
		ReturnType< $bog_builderui_dialog['showed'] >
	>
	type $bog_builderui_dialog__title_bog_builderui_studio_179 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_builderui_dialog['title'] >
	>
	type $bog_builderui_dialog__text_bog_builderui_studio_180 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_builderui_dialog['text'] >
	>
	type $bog_builderui_dialog__close_bog_builderui_studio_181 = $mol_type_enforce<
		ReturnType< $bog_builderui_studio['dialog_close'] >
		,
		ReturnType< $bog_builderui_dialog['close'] >
	>
	type $bog_builderui_dialog__confirm_bog_builderui_studio_182 = $mol_type_enforce<
		ReturnType< $bog_builderui_studio['dialog_confirm'] >
		,
		ReturnType< $bog_builderui_dialog['confirm'] >
	>
	type $bog_builderui_field__hint_bog_builderui_studio_183 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_builderui_field['hint'] >
	>
	type $bog_builderui_field__value_bog_builderui_studio_184 = $mol_type_enforce<
		ReturnType< $bog_builderui_studio['namespace'] >
		,
		ReturnType< $bog_builderui_field['value'] >
	>
	type $bog_builderui_field__hint_bog_builderui_studio_185 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_builderui_field['hint'] >
	>
	type $bog_builderui_field__value_bog_builderui_studio_186 = $mol_type_enforce<
		ReturnType< $bog_builderui_studio['app_name'] >
		,
		ReturnType< $bog_builderui_field['value'] >
	>
	type $bog_builderui_dialog__showed_bog_builderui_studio_187 = $mol_type_enforce<
		ReturnType< $bog_builderui_studio['get_code_showed'] >
		,
		ReturnType< $bog_builderui_dialog['showed'] >
	>
	type $bog_builderui_dialog__title_bog_builderui_studio_188 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_builderui_dialog['title'] >
	>
	type $bog_builderui_dialog__text_bog_builderui_studio_189 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_builderui_dialog['text'] >
	>
	type $bog_builderui_dialog__confirm_title_bog_builderui_studio_190 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_builderui_dialog['confirm_title'] >
	>
	type $bog_builderui_dialog__close_bog_builderui_studio_191 = $mol_type_enforce<
		ReturnType< $bog_builderui_studio['get_code_close'] >
		,
		ReturnType< $bog_builderui_dialog['close'] >
	>
	type $bog_builderui_dialog__confirm_bog_builderui_studio_192 = $mol_type_enforce<
		ReturnType< $bog_builderui_studio['get_code_confirm'] >
		,
		ReturnType< $bog_builderui_dialog['confirm'] >
	>
	type $bog_builderui_dialog__content_bog_builderui_studio_193 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $bog_builderui_dialog['content'] >
	>
	export class $bog_builderui_studio extends $bog_builderui_div {
		favicon_icon( ): $mol_icon_palette
		Favicon( ): $bog_favicon
		lights( next?: string ): string
		base( next?: string ): string
		theme( next?: string ): string
		chart( next?: string ): string
		radius( next?: string ): string
		font_body( next?: string ): string
		font_head( next?: string ): string
		Skin( ): $bog_builderui_skin
		Title( ): $mol_view
		style_id( next?: string ): string
		style_dict( ): Record<string, any>
		Style_pick( ): $bog_builderui_studio_pick
		Group_style( ): $mol_view
		Base_pick( ): $bog_builderui_studio_pick
		Theme_pick( ): $bog_builderui_studio_pick
		Chart_pick( ): $bog_builderui_studio_pick
		Group_colors( ): $mol_view
		Head_pick( ): $bog_builderui_studio_pick
		Body_pick( ): $bog_builderui_studio_pick
		Group_fonts( ): $mol_view
		Radius_pick( ): $bog_builderui_studio_pick
		Lights_pick( ): $bog_builderui_studio_pick
		Group_misc( ): $mol_view
		Spacer( ): $mol_view
		shuffle( next?: any ): any
		Shuffle( ): $mol_button_minor
		share( next?: any ): any
		Share( ): $mol_button_minor
		Actions_row( ): $mol_view
		get_code( next?: any ): any
		Get_code( ): $mol_button_major
		Sidebar( ): $mol_view
		Buttons_title( ): $mol_view
		Btn_primary( ): $bog_builderui_button
		Btn_secondary( ): $bog_builderui_button
		Btn_outline( ): $bog_builderui_button
		Btn_ghost( ): $bog_builderui_button
		Btns_row( ): $mol_view
		Buttons_card( ): $bog_builderui_card
		Badges_title( ): $mol_view
		Badge_one( ): $bog_builderui_badge
		Badge_two( ): $bog_builderui_badge
		Badge_three( ): $bog_builderui_badge
		Badge_four( ): $bog_builderui_badge
		Badges_row( ): $mol_view
		Badges_card( ): $bog_builderui_card
		Tabs_title( ): $mol_view
		tabs_value( next?: string ): string
		Tabs_demo( ): $bog_builderui_tabs
		Tabs_card( ): $bog_builderui_card
		Select_title( ): $mol_view
		select_value( next?: string ): string
		Select_demo( ): $bog_builderui_select
		Select_card( ): $bog_builderui_card
		Card_title( ): $mol_view
		Card_text( ): $mol_view
		Card_demo( ): $bog_builderui_card
		Alert_demo( ): $bog_builderui_alert
		Toasts_title( ): $mol_view
		Toast_info( ): $bog_builderui_toast
		Toast_success( ): $bog_builderui_toast
		Toast_warning( ): $bog_builderui_toast
		Toast_error( ): $bog_builderui_toast
		Toasts_card( ): $bog_builderui_card
		Avatars_title( ): $mol_view
		Avatar_one( ): $bog_builderui_avatar
		Avatar_two( ): $bog_builderui_avatar
		Avatar_three( ): $bog_builderui_avatar
		Avatar_four( ): $mol_avatar
		Avatar_five( ): $mol_avatar
		Avatar_six( ): $mol_avatar
		Avatars_row( ): $mol_view
		Avatars_card( ): $bog_builderui_card
		Sliders_title( ): $mol_view
		slider_value( next?: number ): number
		Slider_demo( ): $bog_builderui_slider
		Sliders_card( ): $bog_builderui_card
		Progress_title( ): $mol_view
		Progress_demo( ): $bog_builderui_progress
		Progress_card( ): $bog_builderui_card
		Tooltip_title( ): $mol_view
		Tooltip_anchor( ): $bog_builderui_button
		Tooltip_demo( ): $bog_builderui_tooltip
		Tooltip_card( ): $bog_builderui_card
		Skeletons_title( ): $mol_view
		Skeleton_title_line( ): $bog_builderui_skeleton
		Skeleton_line_one( ): $bog_builderui_skeleton
		Skeleton_line_two( ): $bog_builderui_skeleton
		Skeletons_card( ): $bog_builderui_card
		Dialog_card_title( ): $mol_view
		dialog_open( next?: any ): any
		Dialog_open_btn( ): $bog_builderui_button
		Dialog_card( ): $bog_builderui_card
		Form_title( ): $mol_view
		Form_subtitle( ): $mol_view
		Form_email_label( ): $mol_view
		Form_email_input( ): $bog_builderui_field
		Form_email_help( ): $mol_view
		Form_email_block( ): $mol_view
		Form_password_label( ): $mol_view
		Form_password_input( ): $bog_builderui_field
		Form_password_block( ): $mol_view
		Form_submit( ): $bog_builderui_button
		Form_secondary( ): $bog_builderui_button
		Form_actions( ): $mol_view
		Form_card( ): $bog_builderui_card
		Field_title( ): $mol_view
		Field_demo( ): $bog_builderui_field
		Field_card( ): $bog_builderui_card
		Menu_title( ): $mol_view
		Menu_item_one( ): $bog_builderui_menu_item
		Menu_item_two( ): $bog_builderui_menu_item
		Menu_item_three( ): $bog_builderui_menu_item
		Menu_demo( ): $bog_builderui_menu
		Menu_card( ): $bog_builderui_card
		Breadcrumbs_title( ): $mol_view
		Breadcrumb_home( ): $bog_builderui_breadcrumbs_item
		Breadcrumb_library( ): $bog_builderui_breadcrumbs_item
		Breadcrumb_data( ): $bog_builderui_breadcrumbs_item
		Breadcrumbs_demo( ): $bog_builderui_breadcrumbs
		Breadcrumbs_card( ): $bog_builderui_card
		Code_title( ): $mol_view
		Code_preview( ): $mol_app_quine
		Code_card( ): $bog_builderui_card
		Chart_title( ): $mol_view
		chart_visits( ): readonly(number)[]
		chart_color_visits( ): string
		Chart_visits( ): $mol_plot_bar
		chart_signups( ): readonly(number)[]
		chart_color_signups( ): string
		Chart_signups( ): $mol_plot_bar
		chart_logins( ): readonly(number)[]
		chart_color_logins( ): string
		Chart_logins( ): $mol_plot_bar
		chart_labels( ): readonly(string)[]
		Chart_mark_hor( ): $mol_plot_mark_hor
		Chart_ruler_vert( ): $mol_plot_ruler_vert
		Chart_demo( ): $bog_builderui_chart
		Chart_card( ): $bog_builderui_card
		Stack( ): $bog_builderui_gallery
		Preview( ): $mol_scroll
		dialog_showed( next?: boolean ): boolean
		dialog_close( next?: any ): any
		dialog_confirm( next?: any ): any
		Dialog_modal( ): $bog_builderui_dialog
		get_code_showed( next?: boolean ): boolean
		get_code_close( next?: any ): any
		get_code_confirm( next?: any ): any
		namespace( next?: string ): string
		Namespace_field( ): $bog_builderui_field
		app_name( next?: string ): string
		App_name_field( ): $bog_builderui_field
		Get_code_dialog( ): $bog_builderui_dialog
		plugins( ): readonly(any)[]
		sub( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=studio.view.tree.d.ts.map